function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { getProductTypeById } from '@finect/front-resources/Products';
import { PercentLabel } from '../../../Products';
import { CellFund } from '../CellFund';
import { empty } from './empty';
import { getPerformanceForPeriod } from './stats';
import { MIN_PRODUCTS, getPlaceholdersQty } from './configs';
export var getPerformanceRows = function getPerformanceRows(productType, funds, inPill, getSheetPath) {
  var emptyPerformanceRow = empty(getPlaceholdersQty(funds, MIN_PRODUCTS)).map(function () {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: null
    });
  });
  var performanceRows = [[''].concat(_toConsumableArray(funds.map(function (fund, index) {
    var fundProductType = productType ? productType : getProductTypeById(fund.subtype);
    return React.createElement(CellFund, {
      key: index,
      productType: fundProductType,
      index: index + 1,
      getSheetPath: getSheetPath,
      fund: fund,
      onDeleteAction: function onDeleteAction() {},
      minimal: true
    });
  }))), ['YTD'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M0', 'accumulated'),
      withSparkline: true
    });
  }))), ['6 meses'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M6', 'accumulated'),
      withSparkline: true
    });
  }))), ['Un año'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M12', 'accumulated'),
      withSparkline: true
    });
  }))), ['Tres años *'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M36', 'annualized'),
      withSparkline: true
    });
  }))), ['Cinco años *'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M60', 'annualized'),
      withSparkline: true
    });
  }))), ['Diez años *'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(PercentLabel, {
      key: "performance",
      value: getPerformanceForPeriod(fund.stats, 'M120', 'annualized'),
      withSparkline: true
    });
  })))];
  if (!inPill) {
    performanceRows.map(function (row) {
      return row.push.apply(row, _toConsumableArray(emptyPerformanceRow));
    });
  }
  return performanceRows;
};